import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApiBaseUrlInterceptor } from "src/app/shared/interceptors/api-base-url.interceptor";
import { RequestLifecycleInterceptor } from "./shared/interceptors/request-lifecycle.interceptor";
// For the Lottie animation on loader
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory(): any {
    return player;
}

@NgModule({
    declarations: [],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule
    ],
    providers: [
        provideLottieOptions({ player: playerFactory }),
        { provide: HTTP_INTERCEPTORS, useClass: ApiBaseUrlInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RequestLifecycleInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule { }
